export default class AccountsReceivableNumber {
    constructor(counter) {
        this.counter = counter || null;
        this.deletable = null;
    }
    static fromData(data) {
        if (!data) {
            return;
        }
        const number = new AccountsReceivableNumber(data.counter);
        number.deletable = data.deletable;

        return number;
    }

    serialize() {
        if(null == this.counter) {
            return null;
        }
        return {
            counter: this.counter
        }
    }
}
